export default __webpack_public_path__ + "static/media/alert-triangle-red.e69a0f51.svg";